import { Provider } from '@angular/core';
import { SensorToolbarConfig, SENSOR_TOOLBAR_CONFIGS } from '../../shared/contracts/toolbar-control.tokens';
import { VF_OPERATOR_KEY } from './vf-toolbar-controls.providers';

/**
 * VesselFinder's toolbar composition. One slot: `live`. No `playback` — there
 * is no refresh-history archive to replay in this phase (`/livedata` is
 * deferred, overview §1.1/§4). No `track`, no `vessel` — both omitted, not
 * declared as `[]`, since there is no per-vessel track bar and no standalone
 * located-vessel bar in this pass (the marker popup and the standing
 * Watched Vessels/Port calls drawers cover what those would have carried).
 */
const VESSELFINDER_CONFIG: SensorToolbarConfig = {
  operatorKey: VF_OPERATOR_KEY,
  capabilities: ['vessel-search', 'priced-actions'],
  live: [
    { id: 'vf-search', order: 5 },
    // Same order Voyage Radar uses for its own port-calls anchor, so the
    // button sits in the same place on both operators' bars.
    { id: 'vf-port-call', order: 22 },
    // Right after Port Calls, before Watched Vessels.
    { id: 'vf-expected-arrivals', order: 28 },
    // Same order Voyage Radar uses for its own Watched Vessels button.
    { id: 'vf-watched-vessels', order: 35 },
  ],
  playback: [],
};

export const VF_TOOLBAR_CONFIG_PROVIDERS: Provider[] = [
  { provide: SENSOR_TOOLBAR_CONFIGS, useValue: VESSELFINDER_CONFIG, multi: true },
];
